import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HEADERS } from 'src/app/constants/services-headers';

@Injectable({ providedIn: 'root' })
export class DatatableService {

  constructor(private http: HttpClient) { }

  /* getFields(): Método común que solicita información al api de indicadores de red de acuerdo a los parámetros recibidos
    url: Dirección del API
    data: Parámetros recibidos desde cada componente
  */
  getFields = (url: string, data: FormData): Observable<any> => this.http.post(url, data, HEADERS);

}
